import { Checkbox, Col, Tooltip } from "antd";
import FormInputDivider from "./FormInputDivider";
import { StyledForm } from "../styles";

function PortalCheckbox({ input, divider, colSpan, ...props }) {
  
  return (
    <FormInputDivider key={input.name} {...divider}>
      <Col span={colSpan ? colSpan : (props.inputColSpan? props.inputColSpan : 24)} key={input.name}>
        <Col span={input?.colSpan ? input.colSpan : 24} style={{padding:"0px"}}>
            <StyledForm.Item {...input} extra={props.helpMessage} valuePropName="checked">
                <Checkbox onChange={input?.onChange} disabled={input?.disabled}>{input?.texto}</Checkbox>
            </StyledForm.Item>
        </Col>
      </Col>
    </FormInputDivider>
  );
}

export default PortalCheckbox;